import axios from "axios";

// Always use the current page's origin for API calls. This eliminates CORS entirely
// because the Emergent ingress routes /api/* on the same hostname to the FastAPI
// backend (works in preview, *.emergent.host, AND custom domains).
// REACT_APP_BACKEND_URL is only used as a fallback during local development (when
// the frontend is served from localhost without an ingress in front of it).
function resolveApiBase() {
  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    // For localhost dev, fall back to the env-configured backend URL if provided.
    if (origin.startsWith("http://localhost") && process.env.REACT_APP_BACKEND_URL) {
      return `${process.env.REACT_APP_BACKEND_URL}/api`;
    }
    return `${origin}/api`;
  }
  return `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
}

export const API_BASE = resolveApiBase();

// Same-origin requests so the httpOnly session_token cookie is sent automatically.
// (We also support a Bearer token in localStorage as a fallback for clients that
// can't accept cookies, but the cookie is the primary, more XSS-resistant path.)
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage as Bearer fallback (cookie is primary)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("notewise_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAuthToken = (token) => {
  if (token) localStorage.setItem("notewise_token", token);
  else localStorage.removeItem("notewise_token");
};

export const getAuthToken = () => localStorage.getItem("notewise_token");
